import {
  INICIALITZAR,
  INTRODUCCIO_OBTENIR_DADES,
  INTRODUCCIO_SHOW_COMMENT,
  ESBORRAR_COMENTARIS
} from "../../actions/actionTypes";

const ESTAT_INICIAL = {};

const valors = (state = ESTAT_INICIAL, action) => {
  switch (action.type) {
    case INICIALITZAR:
      return ESTAT_INICIAL;

    case `${INTRODUCCIO_OBTENIR_DADES}_SUCCESS`:
      return action.payload && action.payload.valors
        ? action.payload.valors
        : {};

    case `${INTRODUCCIO_OBTENIR_DADES}_ERROR`:
      return action.error;

    case `${INTRODUCCIO_SHOW_COMMENT}`:
      return {
        ...state,
        [action.payload]: {
          ...state[action.payload],
          mostrarComentari: !state[action.payload].mostrarComentari
        }
      };

    case `${ESBORRAR_COMENTARIS}`:
      return {
        ...state,
        [action.payload.idIndividuFenofase]: {
          ...state[action.payload.idIndividuFenofase],
          esborrarComentaris: action.payload.valor
        }
      };

    default:
      return state;
  }
};

export default valors;

export const getValors = state => state;
